import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { RoleSummaryDTO } from '../../interfaces/roles.interfaces';
import { expandableRowAnimation } from './expandable-row.animation';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-role-list-table',
  templateUrl: './role-list-table.component.html',
  styleUrls: ['./role-list-table.component.scss'],
  animations: [expandableRowAnimation]
})
export class RoleListTableComponent implements OnInit, OnChanges {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @Input() public roles: Array<RoleSummaryDTO> = [];
  public selectedRoleId: number | null = null;
  public dataSource: MatTableDataSource<RoleSummaryDTO>;
  public spinnerShow: boolean = true;

  constructor(){
    this.dataSource = new MatTableDataSource<RoleSummaryDTO>;
  }

  ngOnInit(): void {
      
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataSource = new MatTableDataSource<RoleSummaryDTO>(this.roles || []);
    this.dataSource.paginator = this.paginator;
  }

  openPermissions(selectedRole: RoleSummaryDTO){
    console.log(selectedRole);
  }

  toggleExpandableRole(roleId: number) {
    this.selectedRoleId = this.selectedRoleId !== null && this.selectedRoleId === roleId ? null : roleId;
  }

  public displayedColumns = [
    'expandArrow',
    'name',
    'description',
    // 'star',
  ]
}
